/**
 * Nachladen wartender E-Mails im Chatter: kurzer Takt in der ersten Minute, danach langer (Bug 1.144: sonst 10 s bis
 * „Probe – würde senden“ erscheint). Reine Regel ohne Uhr: die Zeit kommt als Eingabe (Bug 1.201, Test mit Testuhr).
 */
export const MAIL_FAST_POLL_MS = 1_500;
export const MAIL_FAST_POLL_WINDOW_MS = 60_000;
export const MAIL_SLOW_POLL_MS = 10_000;

export const WAITING_EMAIL = new Set(['sending', 'waiting_unreachable', 'waiting_throttled', 'waiting_quota']);

export interface MailWaitSince {
  key: string;
  at: number;
}

/**
 * `hasWaiting`: ob die geladenen Einträge eine wartende E-Mail enthalten. `key`: Datensatz und Filter (bei Wechsel beginnt
 * die schnelle Minute neu). `since`: Startzeit des Wartens (bisheriger Stand), `now`: Zeit in ms.
 * Ergebnis: `interval` für `refetchInterval` (`false` = nicht nachladen) und der neue Stand von `since`.
 */
export function mailPollStep(hasWaiting: boolean, key: string, since: MailWaitSince | null, now: number): { interval: number | false; since: MailWaitSince | null } {
  if (!hasWaiting) return { interval: false, since: null };
  const start = since?.key === key ? since : { key, at: now };
  return { interval: now - start.at < MAIL_FAST_POLL_WINDOW_MS ? MAIL_FAST_POLL_MS : MAIL_SLOW_POLL_MS, since: start };
}
